import { Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import RoutesContext from "../../../contexts/routes";
import SessionContext from "../../../contexts/session";

import {
  MODULO_COINFLIP,
  MODULO_ROLLADICE,
  MODULO_TWODICE,
  MODULO_ROULETTE,
  MODULO_ETHEROLL,
  ROULETTE_NUMBERS,
  getTwoDiceResult,
} from "../../../games";
import Coinflip from "../../../modules/coinflip";
import Dice from "../../../modules/dice";
import Etheroll from "../../../modules/etheroll";
import { Wheel } from "../../../modules/roulette";
import { getRouletteColor } from "../../../utils";

export default function GameAnimations({ game }) {
  const { executing } = useContext(SessionContext);
  const { executeTransactionUi } = useContext(RoutesContext);
  const [prizeNumber, setPrizeNumber] = useState();
  const [prizeNumber2, setPrizeNumber2] = useState();
  const [mustStartSpinning, setMustStartSpinning] = useState(false);

  function onStopSpinning() {
    setMustStartSpinning(false);
    executeTransactionUi(executing);
  }

  useEffect(() => {
    // we reset prize number for direct game to game transitions to replay default values
    setPrizeNumber();
    setPrizeNumber2();
    setMustStartSpinning(true);
  }, [game]);

  useEffect(() => {
    if (executing) {
      if (game.modulo === Number(executing.modulo)) {
        if (game.modulo === MODULO_COINFLIP) {
          setPrizeNumber(Number(executing.roll));
        } else if (game.modulo === MODULO_ROLLADICE) {
          setPrizeNumber(Number(executing.roll) + 1);
        } else if (game.modulo === MODULO_TWODICE) {
          const result = getTwoDiceResult(Number(executing.roll));
          setPrizeNumber(result[0]);
          setPrizeNumber2(result[1]);
        } else if (game.modulo === MODULO_ROULETTE) {
          setPrizeNumber(
            ROULETTE_NUMBERS.findIndex((n) => n === Number(executing.roll))
          );
        } else {
          setPrizeNumber(Number(executing.roll));
        }
        setMustStartSpinning(true);
      } else {
        // executeTransactionUi(executing);
      }
    }
  }, [executeTransactionUi, executing, game.modulo]);

  return (
    <div>
      {game.modulo === MODULO_COINFLIP && (
        <Coinflip
          mustStartSpinning={mustStartSpinning}
          prizeNumber={prizeNumber}
          onRoll={onStopSpinning}
        />
      )}
      {game.modulo === MODULO_ROLLADICE && (
        <Stack>
          <Dice
            mustStartSpinning={mustStartSpinning}
            cheatValue={prizeNumber}
            onRoll={onStopSpinning}
            size={80}
          />
        </Stack>
      )}
      {game.modulo === MODULO_TWODICE && (
        <Stack direction="row" spacing={4}>
          <Dice
            mustStartSpinning={mustStartSpinning}
            cheatValue={prizeNumber}
            onRoll={onStopSpinning}
            size={80}
          />
          <Dice
            mustStartSpinning={mustStartSpinning}
            cheatValue={prizeNumber2}
            size={80}
          />
        </Stack>
      )}
      {game.modulo === MODULO_ROULETTE && (
        <Wheel
          mustStartSpinning={mustStartSpinning}
          prizeNumber={prizeNumber || 0}
          onStopSpinning={onStopSpinning}
          perpendicularText={true}
          data={ROULETTE_NUMBERS.map((i) => {
            return {
              option: i,
              style: {
                backgroundColor: getRouletteColor(i),
              },
            };
          })}
          backgroundColors={["#3e3e3e", "#df3428"]}
          textColors={["#ffffff"]}
        />
      )}
      {game.modulo === MODULO_ETHEROLL && (
        <Etheroll
          mustStartSpinning={mustStartSpinning}
          prizeNumber={prizeNumber || 77}
          onRoll={onStopSpinning}
        />
      )}
    </div>
  );
}
